"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Definition = _interopRequireDefault(require("../Definition"));

var _humanTime2 = require("../humanTime");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

var _ref2 = _react.default.createElement("span", {
  className: "empty"
}, "\u2014");

var DateTime = function DateTime(_ref) {
  var datetime = _ref.datetime,
      _ref$timeFirst = _ref.timeFirst,
      timeFirst = _ref$timeFirst === void 0 ? false : _ref$timeFirst,
      withSeconds = _ref.withSeconds,
      Icon = _ref.Icon,
      className = _ref.className;

  if (!datetime) {
    return _ref2;
  }

  var _humanTime = (0, _humanTime2.humanTime)(datetime, withSeconds !== undefined ? withSeconds : timeFirst),
      date = _humanTime.date,
      time = _humanTime.time;

  if (timeFirst) {
    return _react.default.createElement(_Definition.default, {
      title: time,
      detail: date,
      Icon: Icon,
      className: className
    });
  }

  return _react.default.createElement(_Definition.default, {
    title: date,
    detail: time,
    Icon: Icon,
    className: className
  });
};

DateTime.propTypes = process.env.NODE_ENV !== "production" ? {
  datetime: _propTypes.default.oneOfType([_propTypes.default.string, _momentPropType.default, _propTypes.default.instanceOf(Date)]),
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.default.Component)]),
  timeFirst: _propTypes.default.bool,
  withSeconds: _propTypes.default.bool,
  className: _propTypes.default.string
} : {};
var _default = DateTime;
exports.default = _default;